ModalExternalResourceController.$inject = ['AppService']

export default function ModalExternalResourceController(AppService) {
  var vm = this

  AppService.getExternalResourceTypes().then(res => vm.externalResourceTypes = res.data)
}